import { MedicalSummaryPanelSettings } from "@/Patient/Models/Settings/MedicalSummaryPanelSettings";
import { MedicalSummaryPanelContext } from "../Components/MedicalSummaryPanel/MedicalSummaryPanelEnums";

export default class MedicalSummaryPanelHelper {
    public static getSavedSettings(context: MedicalSummaryPanelContext): MedicalSummaryPanelSettings {
        let loadedSettings: MedicalSummaryPanelSettings = null;

        switch (context) {
            case MedicalSummaryPanelContext.MedicalNote:
                loadedSettings = cacheStore?.UserSettings?.MedicalNoteMedicalSummaryPanelSettings;
                break;
            case MedicalSummaryPanelContext.PatientLabTab:
            case MedicalSummaryPanelContext.ResultsTab:
                loadedSettings = cacheStore?.UserSettings?.LabViewMedicalSummaryPanelSettings;
                break;
            case MedicalSummaryPanelContext.PharmacyOrders:
                loadedSettings = cacheStore?.UserSettings?.PharmacyOrdersMedicalSummaryPanelSettings;
                break;
            default:
                break;
        }

        return MedicalSummaryPanelSettings.getDeepClonedMedicalSummaryPanelSettings(loadedSettings);
    }
}
